import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CulturalPipe } from '../../../pipes/cultural.pipe';

@Component({
  selector: 'app-savings',
  imports: [MatCardModule, TranslatePipe, CulturalPipe],
  templateUrl: './savings.html',
  styleUrl: './savings.scss'
})
export class Savings {

  constructor( public themeService: CustomizerSettingsService ) {}

}